import React from 'react';

function LoginButton() {
  const handleLogin = () => {
    console.log('Login button clicked - initiating OAuth redirect');
    
    try {
      // Try different redirect approaches
      const oauthUrl = '/social/login/google-oauth2/';
      console.log('Redirecting to:', oauthUrl);
      
      // Method 1: Direct window location
      window.location.href = oauthUrl;
      
      // Fallback: If the above doesn't work, try window.location.assign
      setTimeout(() => {
        console.log('Fallback redirect attempt');
        window.location.assign(oauthUrl);
      }, 100);
      
    } catch (error) {
      console.error('Error during OAuth redirect:', error);
    }
  };

  const handleTestRedirect = () => {
    console.log('Testing OAuth redirect endpoint');
    window.location.href = '/api/test-oauth-redirect/';
  };

  return (
    <div>
      <button onClick={handleLogin} style={{marginRight: '10px'}}>
        Login with Google
      </button>
      <button onClick={handleTestRedirect} style={{backgroundColor: '#f0f0f0'}}>
        Test OAuth (Debug)
      </button>
    </div>
  );
}

export default LoginButton;
